import { Chip, Stack } from '@mui/joy';
import type { ReactElement } from 'react';
import { IPortfolioDefinitionSubType, IPortfolioDefinitionType } from '../../../../generated/graphql.tsx';
import type { PortfolioDefActionDef } from './PortfolioDefinitionActions.tsx';
import { getPortfolioRebalancingStatus } from './PortfolioDefCards.utils.tsx';
import { formatEnum } from '../../../formatter.utils.ts';

interface PortfolioStatusIndicatorsProps {
  def: PortfolioDefActionDef;
}

export const PortfolioStatusIndicators = ({ def }: PortfolioStatusIndicatorsProps): ReactElement => {
  const rebalancingStatus = getPortfolioRebalancingStatus(def);

  return (
    // cancel out the gap of the parent
    <Stack direction="row" spacing={0.5} flexWrap="wrap">
      <Chip color="primary" size="sm" variant="outlined">
        {rebalancingStatus}
      </Chip>

      {def.type === IPortfolioDefinitionType.Rebalanced && (
        <Chip color="primary" size="sm" variant="soft">
          {def.subType === IPortfolioDefinitionSubType.Default ? 'Composition based' : formatEnum(def.subType)}
        </Chip>
      )}
    </Stack>
  );
};
